import auth from './auth';

import featureAvailabilityRules from '../config/featureAvailabilityRules.json';
import featureLabelRules from '../config/featureLabelRules.json';
import featureLimitRules from '../config/featureLimitRules.json';

class FeatureAvailabilityService {
  user = null;

  install(Vue) {
    Vue.prototype.$featureAvailabilityService = this;
    Vue.filter('translateFeatureLabel', (featureKey) => {
      return this.translateLabel(featureKey);
    });
  }

  updateUser(user) {
    this.user = user;
  }

  _evaluateRule(rule) {
    if (!rule.condition) {
      return true;
    }
    // Rules are AND'ed by default
    // So if one fails we return false
    // Otherwise we return true
    if (rule.condition.productType) {
      if (!this.user) {
        return false;
      }
      if (this.productType() !== rule.condition.productType) {
        return false;
      }
    }
    return true;
  }

  isAvailable(featureKey) {
    const availabilityRules = featureAvailabilityRules[featureKey];
    const firstPassingRule = (availabilityRules || []).find(rule => this._evaluateRule(rule));
    return firstPassingRule ? firstPassingRule.available : false;
  }

  translateLabel(labelKey) {
    const labelRules = featureLabelRules[labelKey];
    const firstPassingRule = (labelRules || []).find((rule) =>
      this._evaluateRule(rule)
    );
    return firstPassingRule ? firstPassingRule.label.en : labelKey;
  }

  getLimit(limitKey) {
    const limitRules = featureLimitRules[limitKey];
    const firstPassingRule = (limitRules || []).find(rule => this._evaluateRule(rule));
    return firstPassingRule ? firstPassingRule.value : -1;
  }

  productType() {
    return this.user ? this.user['https://vrpatients.com/productType'] : 'EMS';
  }
}

const featureAvailabilityService = new FeatureAvailabilityService();

featureAvailabilityService.updateUser(auth.getUser());

export default featureAvailabilityService;
